import React from 'react';
import Chart from 'react-apexcharts';

class WidgetBarGraph extends React.Component {
  render() {
    const table = this.props.table;

    const series = [
      {
        data: [],
      }
    ];

    const options = {
      title: {
        text: this.props.name,
        align: 'middle'
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
          barHeight: '80%',
          isFunnel: true,
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val, opt) => opt.w.globals.labels[opt.dataPointIndex] + ' : ' + val,
        dropShadow: {
          enabled: true,
        },
      },
      xaxis: {
        categories: [ ],
      },
      legend: {
        show: false
      },
      chart: {
        events: {
          dataPointSelection: (_, __, config) => {
            console.log(config.dataPointIndex);
          }
        }
      }
    };

    for(let i = 1; i < table.length - 1; i++) {
      options.xaxis.categories.push(table[i][0]);
      series[0].data.push(table[i][1]);
    }

    return(
      <div className={`col-md-${this.props.report ? 12 : 4}`}>
        <Chart options={options} series={series} type="bar" height={320} />
      </div>
    );
  }
}
export default WidgetBarGraph;